<script lang="ts">
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import compareVersions from 'compare-versions';

	export let device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	const deviceFWVersion = settings?.DeviceInfo?.ver.split('-')[0];
	const supportedVersionMaxValue = '0.14.2'; //needed confirmation about supported min version about this setting increase
	const min = 0.25,
		max =
			deviceFWVersion === '1.0.99'
				? 2
				: compareVersions(settings?.DeviceInfo?.ver.split('-')[0], supportedVersionMaxValue) > -1
					? 2
					: 0.75;

	let value = settings[get_gen_2_component_channel_structure(device)].motor.idle_confirm_period,
		loading = false;

	$: disabled = value < min || value > max;

	const changeConfirmPeriod = async () => {
		loading = true;
		const res = await gen2Request(device, `${get_gen_2_component_from_category(device)}.SetConfig`, {
			id: device.channel,
			config: { motor: { idle_confirm_period: value } },
		});
		if (res.isok) {
			settings[get_gen_2_component_channel_structure(device)].motor.idle_confirm_period = value;
			devices_settings.update_devices_settings(device.id, settings);
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
		} else if (res?.errors?.message) {
			toast.open({ type: 'danger', title: res?.errors?.message });
		} else {
			toast.open({ type: 'danger', title: $format('setting_err_toast') });
		}
		loading = false;
	};
</script>

<Text class="mb-s" styleType="body-small">
	{$format('delay_time_descr_cover', {
		//TODO need to remove ms instead of s
		default: 'Delay time when changing directions. Values {min}-{max}ms.',
		values: { min, max },
	})}
</Text>

<Input
	size="m"
	class="mb-s"
	type={'number'}
	{min}
	{max}
	step={0.01}
	bind:value
	id="input-xgprcqc"
	aria-label={$format('delay_time_descr_cover', {
		//TODO need to remove ms instead of s
		default: 'Delay time when changing directions. Values {min}-{max}ms.',
		values: { min, max },
	})}
/>

<Button {loading} {disabled} size="m" width="full" on:click={changeConfirmPeriod}
	>{$format('button_save')}</Button
>
